import { gpHome } from '../app';
import {
    IAiCreditsApi,
    AiCreditBalance,
    AiCreditsServiceName,
} from './ai-credits-contract';

import type * as ng from 'angular';

/**
 * Real AI-credits service. GETs the logged-in user's credit position from the web
 * role (`api/ai-credits/balance`), which resolves the owner + Stripe billing period
 * and assembles the balance from the ledger via the shared logic. Implements the
 * same {@link IAiCreditsApi} the mock does, so swapping the registration in main.ts
 * is the only change required — the directive and template are untouched.
 */
class AiCreditsService implements IAiCreditsApi {

    static $inject = ['$http'];
    static serviceName = AiCreditsServiceName;

    private readonly serviceBase = __gameplan_service_url || 'http://localhost/';

    constructor(private readonly $http: ng.IHttpService) { }

    getBalance() {
        return this.$http
            .get<AiCreditBalance>(this.serviceBase + 'api/ai-credits/balance')
            .then(response => response.data);
    }
}

gpHome.service(AiCreditsService.serviceName, AiCreditsService);
